var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriptenLogoRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8243 5.95559C29.8492 5.06896 26.0654 1.66098 26.0654 1.66098C25.1964 0.826299 23.7972 0.677363 22.0969 1.11029C19.2984 1.82029 14.8748 4.30008 10.1433 9.84498L14.5293 13.4019C11.1834 16.7129 7.63219 18.9503 4.86789 19.6533C5.32633 16.9311 7.21139 13.3396 10.1433 9.84845L5.16896 5.81359C0.430646 11.5247 -1.19441 17.2151 0.895922 19.1027C2.98625 20.9902 5.65476 23.3973 5.65476 23.3973C6.52374 24.2319 7.92299 24.3809 9.62331 23.9479C12.4526 23.2276 17.0917 20.5781 21.6795 15.0886L17.3072 11.5421C20.6189 8.29339 24.1222 6.10105 26.8523 5.40837C26.3973 8.09943 24.5533 11.639 21.6795 15.0886L26.6539 19.1234C30.9645 13.9734 33.0378 7.97475 30.8208 5.95905L30.8243 5.95559Z",
    fill: "#FCEA51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriptenLogoRed);
export default __webpack_public_path__ + "static/media/cripten_logo_red.7f927c43425a12486f742fc9fc2f0243.svg";
export { ForwardRef as ReactComponent };